module.exports = __webpack_public_path__ + "assets/img/deviceOffline.d8f77c17.png";